import { Grid } from '@material-ui/core';
import React from 'react';
import { useStyles } from './NetworkStyle';
export default function Network() {
  const style = useStyles();
  return (
    <div>
      <div className={style.networkDiv}>
        <Grid container>
          <Grid item xl={3} lg={3} md={12} sm={12} xs={12} className={style.divsAlign}>
            <div className={style.awsText}> AWS Privatelink</div>
          </Grid>
          <Grid item xl={4} lg={4} md={12} sm={12} xs={12} className={style.divsAlign}>
            <div className={style.networkDiv2}>
              Service needs to be in a project vpc and in a supported region to
              create a privatelink.
            </div>
          </Grid>
          <Grid item xl={5} lg={5} md={12} sm={12} xs={12} >
            <div className={style.usEastAlign}>
              <div>
                <div  className={style.usEastTxt}>$0.6/6GB (aws-us-east-2)</div>
                <div>
                  <button className={style.privateButton}>
                    Create Privatelink
                  </button>
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
}
